<template>
  <div class="order-view">
    <audio ref="audioPlayer" @ended="onAudioEnded" @error="onAudioError" style="display:none"></audio>
    <!-- 多订单卡片容器 -->
    <div class="order-cards-container">
      <!-- 循环渲染每个订单卡片 -->
      <div class="order-card" v-for="(orderInfo, index) in orderList" :key="index">
        <!-- 订单卡片头部 -->
        <div class="order-header">
          <h2 class="order-title">订单信息 {{ index + 1 }}</h2>
          <div class="order-meta">
            <p class="order-id">订单号：{{ orderInfo.orderData.orderId }}</p>
            <p class="shop-address">{{ orderInfo.orderData.shopAddress }}</p>
            <p class="shop-name">{{ orderInfo.orderData.shopName }}</p>
          </div>
          
          <div class="order-pattern-container" 
               style="display: flex; 
                      flex-direction: column; 
                      gap: 4px;
                      align-items: flex-start; /* 添加左对齐 */
                      width: 100%; /* 确保宽度占满 */">
            <span class="order-pattern">{{ orderInfo.orderData.orderPattern }}</span>
            <span class="order-total">
              <span :key="orderInfo.orderData.totalCount" class="animate-target">
                共{{ orderInfo.orderData.totalCount }}件商品
              </span>
            </span>
          </div>
        </div> 
        <button class="speak-btn" @click="speakOrder(index)" :disabled="speakingIndex === index">
                      <span class="speak-icon">🔊</span>
                      {{ speakingIndex === index ? '播报中...' : '语音播报' }}
        </button>

        <!-- 颜色指示器 -->
        <div class="color-indicator" :style="{ backgroundColor: orderInfo.lightColor.hex }">
          请留意货架上 
            <span class="blink-text">{{ orderInfo.lightColor.name }}</span>
            灯光指引
        </div>

        <!-- 商品清单表格 -->
        <div class="product-summary-table-container" v-for="(orderInfo, index) in orderList" :key="'table-'+index">
          <div class="summary-table-header">
            <h3>库位码清单</h3>
            <!-- <span class="summary-count">共 {{ orderInfo.orderData.items.length }} 件商品</span> -->
            <span class="summary-count">共 {{ orderInfo.orderData.totalCount }} 件商品</span>
          </div>
          <div class="summary-table-wrapper">
            <table class="summary-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <!-- <th>商品名称</th> -->
                  <th>库位码</th>
                  <th>件数</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, itemIdx) in orderInfo.orderData.items" :key="'summary-'+itemIdx"
                    :class="{ 'found-row': item.status === 'found', 'not-found-row': item.status === 'not_found' }">
                  <td class="col-sn">{{ itemIdx + 1 }}</td>
                  <td class="col-location">{{ item.originalSheltNumber || '--' }}</td>
                  <td class="col-quantity">
                    <span class="quantity-badge">{{ item.itemQuantity || 1 }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <!-- 新增：向下箭头按钮区域 -->
                <div class="expand-button-container">
                  
                  <div class="expand-arrow" v-if="expandedDetails[index]" @click="toggleDetailsExpand(index)" :class="{ 'expanded': expandedDetails[index] }">
                      <span class="arrow-icon">↑</span>
                      <span class="expand-text">点击收起商品详情</span>
                    </div>
                  <div class="blinking-arrow" v-if="!expandedDetails[index]" @click="toggleDetailsExpand(index)">
                    <span class="arrow-icon blinking">↓</span>
                   <span class="hint-text">点击查看商品详情</span>
                  </div>
                </div>

        <!-- 商品列表 -->
        <div class="product-list" v-show="expandedDetails[index] === true">
          <h3>商品详情清单</h3>
          <div class="product-item" v-for="(item, itemIndex) in orderInfo.orderData.items" :key="itemIndex">
            <div v-if="itemIndex > 0" class="product-divider"></div>
            <!-- 商品项内容保持不变 -->
            <div class="product-container">
              <!-- 图片区域 -->
              <div class="image-container" @click="showImagePreview(item.imageUrl)">
                <img :src="item.imageUrl" alt="商品图片" class="product-image" v-if="item.imageUrl" />
                <div class="no-image-tip" v-else>
                          请按灯光指引及货架号拿取对应商品
                        </div>
                <div class="image-overlay">点击放大</div>
              </div>

              <!-- 信息区域 -->
              <div class="info-container">
                <p class="product-name">{{ item.itemName }}</p>
                <div class="meta-info">
                  <p class="shelf-number">货架号：{{ item.originalSheltNumber || "无" }}</p>
                  <p class="quantity">
                    <span :key="item.itemQuantity" class="animate-target">
                      拿 {{ item.itemQuantity }} 件
                    </span>
                  </p>
                </div>
              </div>

              <!-- 操作按钮 -->
              <div class="action-buttons">
                <button class="found-btn" @click="markAsFound(index, itemIndex)" :disabled="item.status === 'found'"
                  :class="{ 'disabled': item.status === 'found' }">
                  已找到
                </button>
                <button class="not-found-btn" @click="markAsNotFound(index, itemIndex)"
                  @mousedown="activeNotFound = `${index}-${itemIndex}`" @mouseup="activeNotFound = null"
                  @mouseleave="activeNotFound = null" :class="{ 'active': activeNotFound === `${index}-${itemIndex}` }">
                  找不到
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览模态框 -->
    <div v-if="showPreview" class="image-modal" @click.self="closePreview">
      <div class="modal-content">
        <img :src="previewImageUrl" alt="商品大图" class="modal-image" @click="closePreview">
        <div v-if="loadingImage" class="loading-indicator">图片加载中...</div>
        <div v-if="imageError" class="error-indicator">图片加载失败</div>
        <div class="close-btn-container" @click="closePreview">
          <div class="close-btn-icon">
            <span class="close-bar"></span>
            <span class="close-bar"></span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        speakingIndex: null, // 当前正在播报的订单索引
        speakSupported: true, // 是否支持语音
        currentAudio: null,
        color: '', // 颜色名称
        colorHex: '#FFFFFF', // 颜色十六进制代码
        activeNotFound: null,
        orderData: {},
        orderInfo: {},
        orderList: [],
        expandedDetails: [], // 控制每个订单的商品详情是否展开
        showPreview: false, // 控制模态框显示
        previewImageUrl: '', // 预览的图片URL
        loadingImage: false, // 图片加载状态
        imageError: false // 图片加载错误
      };
    },
    
    watch: {
        orderList: {
          handler(newList) {
            if (newList && newList.length) {
              // 确保所有订单初始都是收起状态
              this.expandedDetails = newList.map(() => false);
            } else {
              this.expandedDetails = [];
            }
            console.log('expandedDetails 已初始化:', this.expandedDetails);
          },
          immediate: true,
          deep: true
        }
      },

    created() {
      //this.loadFromSessionStorage();
      this.loadOrderData();
      if (this.orderList && this.orderList.length) {
            this.expandedDetails = this.orderList.map(() => false);
          }
    },
    
    // mounted() {
    //     // 页面加载完成后，自动播报所有订单
    //     this.$nextTick(() => {
    //       // 检查浏览器是否支持语音
    //       if (!window.speechSynthesis) {
    //         this.speakSupported = false;
    //         console.warn('当前浏览器不支持语音播报');
    //         return;
    //       }
          
    //       // 延迟一点播报，确保页面渲染完成
    //       setTimeout(() => {
    //         this.speakAllOrders();
    //       }, 500);
    //     });
    //   },
    
    mounted() {
      // ✅ 监听用户首次触摸，触发语音播报（微信必须这样做）
      const triggerSpeak = () => {
        // 移除监听，只触发一次
        document.removeEventListener('touchstart', triggerSpeak);
        document.removeEventListener('click', triggerSpeak);
        
        // 触发播报
        if (this.orderList && this.orderList.length > 0) {
          this.speakAllOrders();
        }
      };
      
      document.addEventListener('touchstart', triggerSpeak, { once: true, passive: true });
      document.addEventListener('click', triggerSpeak, { once: true });
    },
    
    beforeRouteEnter(to, from, next) {
      // 在路由进入前检查sessionStorage
      const savedColor = sessionStorage.getItem('orderColor');
      const savedColorHex = sessionStorage.getItem('orderColorHex');

      if (savedColor && savedColorHex) {
        // 如果sessionStorage中有值，添加到路由参数
        to.params.color = savedColor;
        to.params.colorHex = savedColorHex;
      }
      next();
    },

    methods: {
      loadFromSessionStorage() {
        const storageKey = this.$route.query.key;
        if (!storageKey) {
          console.error('缺少存储键');
          return;
        }

        const storedData = JSON.parse(sessionStorage.getItem(storageKey));
        if (!storedData) {
          console.error('未找到存储数据');
          return;
        }

        // 加载订单数据
        this.orderInfo = storedData.orderData;
        console.log('加载的orderData:', storedData.orderData);

        // 加载颜色信息
        if (storedData.lightColor) {
          this.color = storedData.lightColor.name;
          this.colorHex = storedData.lightColor.hex;
          console.log('加载的颜色信息:', this.color, this.colorHex);
        }

        // 清除存储（可选）
        sessionStorage.removeItem(storageKey);
      },

      loadOrderData() {
        const key = this.$route.query.key;
        const storageData = JSON.parse(sessionStorage.getItem(key));
        if (storageData && storageData.orders) {
          this.orderList = storageData.orders;
        }
      },

     
        
      toggleDetailsExpand(orderIndex) {
            console.log('切换前状态:', this.expandedDetails[orderIndex]);
            
            // 确保 expandedDetails 数组有足够的长度
            if (!this.expandedDetails || this.expandedDetails.length <= orderIndex) {
              const newExpanded = new Array(this.orderList.length).fill(false);
              this.expandedDetails = newExpanded;
            }
            
            // 切换状态
            this.expandedDetails[orderIndex] = !this.expandedDetails[orderIndex];
            
            console.log('切换后状态:', this.expandedDetails[orderIndex]);
            
            // 如果视图没有更新，可以尝试强制更新（不推荐，但作为调试手段）
            this.$forceUpdate();
          },
      
      async markAsFound(orderIndex, itemIndex) {
        // 获取订单和商品引用
        const order = this.orderList[orderIndex];
        const items = [...order.orderData.items]; // 创建新数组确保响应式
        
        // 如果商品已经是已找到状态，直接返回
        if (items[itemIndex].status === 'found') return;
      
        try {
          // 1. 更新商品状态 - 使用对象扩展创建新对象
          const updatedItem = {
            ...items[itemIndex],
            status: 'found'
          };
          
          // 2. 创建新数组并替换原数组
          const updatedItems = [
            ...items.slice(0, itemIndex),
            updatedItem,
            ...items.slice(itemIndex + 1)
          ];
          
          // 3. 更新订单数据 - 使用对象扩展创建新对象
          const updatedOrder = {
            ...order,
            orderData: {
              ...order.orderData,
              items: updatedItems
            }
          };
          
          // 4. 更新订单列表 - 使用数组扩展创建新数组
          this.orderList = [
            ...this.orderList.slice(0, orderIndex),
            updatedOrder,
            ...this.orderList.slice(orderIndex + 1)
          ];
          
          // 5. 发送关灯请求
          const response = await fetch('/api/device/turn-off-single', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              storeId: order.orderData.storeId,
              sheltNumber: items[itemIndex].sheltNumber
            })
          });
      
          if (!response.ok) {
            throw new Error(await response.text());
          }
      
          console.log('关灯成功:', items[itemIndex].sheltNumber);
          
          // 6. 检查是否所有商品都已找到
          const allFound = updatedItems.every(item => item.status === 'found');
          if (allFound) {
            console.log('该订单所有商品已找到！');
            // 可以添加通知或状态更新
          }
          
           // 7.恢复展开状态
              await this.$nextTick();
                 this.expandedDetails[orderIndex] = true;
                 // 强制触发响应式更新
                 this.expandedDetails = [...this.expandedDetails];
        } catch (err) {
          console.error('关灯失败:', err);
          // 错误处理 - 不需要回滚状态，因为状态更改是局部的
        }
      },
      
      // 检查订单中所有商品是否都已找到
      checkAllItemsFound(orderIndex) {
        const order = this.orderList[orderIndex];
        return order.orderData.items.every(item => item.status === 'found');
      },
      
      async markAsNotFound(orderIndex, itemIndex) {
        const order = this.orderList[orderIndex];
        const item = order.orderData.items[itemIndex];
        //const currentExpandedState = [...this.expandedDetails];
        try {
          // 处理找不到商品的逻辑
          // ...
          item.status = 'not_found';
          // 如果需要保持状态一致
          //this.$set(item, 'status', 'not_found');
          
           // 恢复展开状态
             // 恢复展开状态
                 await this.$nextTick();
                 this.expandedDetails[orderIndex] = true;
                 // 强制触发响应式更新
                 this.expandedDetails = [...this.expandedDetails];
          
        } catch (err) {
          console.error('操作失败:', err);
          this.$toast.error('操作失败: ' + err.message);
        }
      },
      
      // 显示图片预览 - 添加触摸事件支持
      showImagePreview(imageUrl) {
        this.previewImageUrl = imageUrl;
        this.showPreview = true;
        this.loadingImage = true;
        this.imageError = false;

        const img = new Image();
        img.onload = () => {
          this.loadingImage = false;
        };
        img.onerror = () => {
          this.loadingImage = false;
          this.imageError = true;
        };
        img.src = imageUrl;

        // 添加触摸事件支持
        document.addEventListener('touchstart', this.handleTouchStart, {
          passive: true
        });
        document.addEventListener('touchend', this.handleTouchEnd);
      },
      
      /**
           * 构建单个订单的播报文本
           */
          buildSpeakText(orderInfo, orderIndex) {
            const order = orderInfo.orderData;
            // 判断订单平台：可以从orderPattern或orderId中提取
            let platform = '订单';
            
            if (order.pType === 'MT') {
                platform = '美团';
              } else if (order.pType === 'ELE') {
                platform = '饿了么';
              } else {
                // 后备方案：从 orderPattern 提取
                if (order.orderPattern) {
                  if (order.orderPattern.includes('美团')) platform = '美团';
                  else if (order.orderPattern.includes('饿了么')) platform = '饿了么';
                }
              }
            
            // 提取订单序号（从orderId中提取数字）
            //const orderNum = order.orderId.replace(/\D/g, '') || orderIndex + 1;
            const orderNum = order.orderPattern || orderIndex + 1;
            //alert(order.orderPattern)
            
            // 构建商品信息
            let itemsText = '';
            const items = order.items || [];
            items.forEach((item, idx) => {
              const location = item.originalSheltNumber || item.sheltNumber || '未知库位';
              const qty = item.itemQuantity || 1;
              itemsText += `其中${location}拿${qty}件`;
              if (idx < items.length - 1) {
                itemsText += '，';
              }
            });
            
            // 完整播报文本
            // 如果只有一个订单，直接播报；如果有多个订单，加上序号区分
            let fullText = `骑手你好，`;
            
            let colorText ='';
            colorText = orderInfo.lightColor.name;
            if (this.orderList.length > 1) {
              fullText += `第${orderIndex + 1}个订单，`;
            }
            fullText += `${platform}${orderNum}，共${order.totalCount || items.length}件商品，${itemsText}，请留意货架上${colorText}灯光指引，谢谢。`;
            
            return fullText;
          },
          
          
          /**
               * 播报所有订单（依次播报）
               */
              // speakAllOrders() {
              //   if (!this.speakSupported || !this.orderList || this.orderList.length === 0) {
              //     return;
              //   }
                
              //   // 取消之前的播报
              //   window.speechSynthesis.cancel();
                
              //   // 依次播报每个订单
              //   this.orderList.forEach((orderInfo, index) => {
              //     const text = this.buildSpeakText(orderInfo, index);
              //     // 每个订单播报之间间隔0.5秒
              //     setTimeout(() => {
              //       this.speakText(text, index);
              //     }, index * 800);
              //   });
              // },
              async speakAllOrders() {
                if (!this.orderList || this.orderList.length === 0) return;
                
                const fullText = this.orderList
                  .map((orderInfo, i) => this.buildSpeakText(orderInfo, i))  // 遍历，生成每段文本
                  .join('。');
                  
                await this.speakText(fullText, 0);
                
                // 依次播报（避免同时播放多个音频）
                // for (let i = 0; i < this.orderList.length; i++) {
                //   const text = this.buildSpeakText(this.orderList[i], i);
                //   try {
                //     await this.speakText(text, i);
                //   } catch (err) {
                //     console.error('播报失败:', err);
                //   }
                // }
              },
              
              
               /**
                   * 播报单个订单（点击按钮触发）
                   */
                  // speakOrder(index) {
                  //   if (!this.speakSupported) {
                  //     alert('您的浏览器不支持语音播报功能');
                  //     return;
                  //   }
                    
                  //   const orderInfo = this.orderList[index];
                  //   if (!orderInfo) return;
                    
                  //   // 如果正在播报，先取消
                  //   if (this.speakingIndex !== null) {
                  //     window.speechSynthesis.cancel();
                  //     if (this.speakingIndex === index) {
                  //       this.speakingIndex = null;
                  //       return;
                  //     }
                  //   }
                    
                  //   const text = this.buildSpeakText(orderInfo, index);
                  //   alert(text)
                  //   this.speakText(text, index);
                  // },
                  
                  // async speakOrder(index) {
                  //   const orderInfo = this.orderList[index];
                  //   if (!orderInfo) return;
                    
                  //   // 如果正在播报，先停止当前音频（防止重叠）
                  //   if (this.currentAudio) {
                  //     this.currentAudio.pause();
                  //     this.currentAudio = null;
                  //   }
                    
                  //   // 如果点击的是正在播报的订单，则停止播报
                  //   if (this.speakingIndex === index) {
                  //     this.speakingIndex = null;
                  //     return;
                  //   }
                    
                  //   const text = this.buildSpeakText(orderInfo, index);
                  //   await this.speakText(text, index);
                  // },
                  
                  async speakOrder(index) {
                    const orderInfo = this.orderList[index];
                    if (!orderInfo) return;
                    
                    const audioPlayer = this.$refs.audioPlayer;
                    
                    // 停止当前播放
                    if (audioPlayer) {
                      audioPlayer.pause();
                      audioPlayer.currentTime = 0;
                    }
                    
                    // 如果点击的是正在播报的订单，则停止播报
                    if (this.speakingIndex === index) {
                      this.speakingIndex = null;
                      return;
                    }
                    
                    const text = this.buildSpeakText(orderInfo, index);
                    await this.speakText(text, index);
                  },
             
             
             /**
                  * 核心语音播报方法
                  */
                 // speakText(text, index) {
                 //   // 检查浏览器支持
                 //   if (!window.speechSynthesis) {
                 //     console.error('浏览器不支持语音播报');
                 //     return;
                 //   }
                   
                 //   // 取消当前正在播报的语音
                 //   window.speechSynthesis.cancel();
                   
                 //   // 创建语音实例
                 //   const utterance = new SpeechSynthesisUtterance(text);
                 //   utterance.lang = 'zh-CN';
                 //   utterance.rate = 0.9;      // 语速 0.1-10
                 //   utterance.pitch = 1.0;     // 音调 0-2
                 //   utterance.volume = 1.0;    // 音量 0-1
                   
                 //   const voices = window.speechSynthesis.getVoices();
                 //     const zhVoice = voices.find(v => v.lang.startsWith('zh'));
                 //     if (zhVoice) {
                 //       utterance.voice = zhVoice;
                 //     }
                   
                 //   // 设置播报状态
                 //   this.speakingIndex = index;
                   
                 //   // 监听事件
                 //   utterance.onstart = () => {
                 //     console.log('开始播报:', text);
                 //   };
                   
                 //   utterance.onend = () => {
                 //     console.log('播报完成');
                 //     this.speakingIndex = null;
                 //   };
                   
                 //   utterance.onerror = (e) => {
                 //     console.error('播报出错:', e.error);
                 //     this.speakingIndex = null;
                 //     // 如果是用户取消操作导致的错误，不提示
                 //     if (e.error !== 'canceled') {
                 //       console.warn('语音播报失败，请重试');
                 //     }
                 //   };
                   
                 //   // 执行播报
                 //   window.speechSynthesis.speak(utterance);
                 // },
                 
                 
                 
                 async speakText(text, index) {
                   try {
                     const audioPlayer = this.$refs.audioPlayer;
                     if (!audioPlayer) throw new Error('音频播放器未就绪');
                     
                     audioPlayer.pause();
                     audioPlayer.currentTime = 0;
                     
                     const t0 = Date.now();
                     audioPlayer.src = `/api/tts/stream?text=${encodeURIComponent(text)}`;
                     audioPlayer.load();
                     
                     this.speakingIndex = index;
                     
                     await audioPlayer.play();
                     console.log('【从请求到出声总耗时】', Date.now() - t0, 'ms');
                     
                   } catch (err) {
                     console.error('语音播报失败:', err);
                     this.speakingIndex = null;
                   }
                 },
                 
                 // 新增：音频播放结束
                 onAudioEnded() {
                   this.speakingIndex = null;
                 },
                 
                 // 新增：音频播放错误
                 onAudioError(e) {
                   console.error('音频播放错误:', e);
                   this.speakingIndex = null;
                 },
                 
                  
                 
                        
                         
      

      // 关闭预览 - 移除触摸事件
      closePreview() {
        this.showPreview = false;
        document.removeEventListener('touchstart', this.handleTouchStart);
        document.removeEventListener('touchend', this.handleTouchEnd);
      },

      // 触摸事件处理
      handleTouchStart(e) {
        this.touchStartX = e.touches[0].clientX;
        this.touchStartY = e.touches[0].clientY;
      },

      handleTouchEnd(e) {
        if (!this.showPreview) return;

        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;

        // 计算滑动距离
        const diffX = Math.abs(touchEndX - this.touchStartX);
        const diffY = Math.abs(touchEndY - this.touchStartY);

        // 如果是轻点（非滑动），则关闭预览
        if (diffX < 10 && diffY < 10) {
          this.closePreview();
        }
      }
    }
  }
</script>

<style scoped>
  .order-view {
    /* 背景分层叠加 */
    background:
      /* 第三层：纯色粉红底 */
      linear-gradient(rgba(255, 105, 180, 0.1), rgba(255, 105, 180, 0.1)),
      /* 第二层：垂直渐变 */
      url('~@/assets/images/vertical-gradient.png'),
      /* 第一层：圆角渐变 */
      url('~@/assets/images/gradient-top-bottom.png');

    background-size:
      100% 30%,
      /* 纯色层覆盖30%高度 */
      cover,
      /* 垂直渐变全尺寸 */
      100% 100%;
    /* 圆角渐变全尺寸 */
    background-position:
      bottom,
      /* 纯色层在底部 */
      center,
      /* 垂直渐变居中 */
      center;
    /* 圆角渐变居中 */
    background-repeat: no-repeat;

    /* 保持原有布局 */
    min-height: 100vh;
    padding: 15px;
    overflow-y: auto;
  }
  
/*260910 add */
/* 语音播报按钮 */
.speak-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #4A90D9, #357ABD);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(74, 144, 217, 0.3);
  flex-shrink: 0;
  margin-left: 10px;
  min-height: 40px;
}

.speak-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(74, 144, 217, 0.4);
}

.speak-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.speak-btn:disabled {
  background: #999;
  cursor: not-allowed;
  box-shadow: none;
}

.speak-btn .speak-icon {
  font-size: 18px;
}

/* 播报动画 */
.speak-btn.speaking {
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

/* add end*/

.order-cards-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
}

.order-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-bottom: 20px;
}

/* 调整原样式适应卡片布局 */
.order-header, .color-indicator, .product-list {
  margin-bottom: 15px;
}

  .order-header {
    position: relative;
    z-index: 2;
    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 0.8));
    backdrop-filter: blur(8px);
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
  }

  .order-title {
    font-size: 18px;
    color: #333;
    margin-bottom: 12px;
    font-weight: bold;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .order-header h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .order-meta p {
    margin: 6px 0;
    font-size: 12px;
    color: #666;
    line-height: 1.5;
  }

  .order-id {
    color: #333;
    font-size: 20px;
    font-weight: bold;
  }

  .shop-name {
    color: #1a73e8;
    font-size: 20px;
    font-weight: bold;
  }

  .order-pattern-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px dashed #ddd;
  }

  .order-pattern {
    font-weight: bold;
    font-size: 1.2rem;
    color: #e44d26;
  }

  .order-total {
    font-weight: bold;
    font-size: 1.1rem;
    color: #2c3e50;
    background-color: #f0f7ff;
    padding: 5px 12px;
    border-radius: 15px;
    border: 1px solid #d0e3ff;
  }
  
  .no-image-tip {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
    color: #666;
    font-size: 14px;
    line-height: 1.4;
    background-color: #f5f5f5;
    border-radius: 4px;
  }

  .product-list {
    display: block;
    background-color: white;
    border-radius: 8px;
    padding: 15px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .product-list h3 {
    font-size: 16px;
    color: #333;
    margin-bottom: 15px;
    font-weight: bold;
  }

  .product-item {
    position: relative;
    z-index: 1;
    background: linear-gradient(135deg,
        rgba(255, 255, 255, 0.9),
        rgba(255, 255, 255, 0.8));
    backdrop-filter: blur(6px);
    border-radius: 10px;
    padding: 15px;
    backdrop-filter: blur(6px);
  }

  .product-item:last-child {
    border-bottom: none;
  }

  .product-info {
    flex: 1;
    min-width: 0;
  }

  .product-name {
    font-size: 15px;
    color: #333;
    font-weight: bold;
    margin: 0 0 5px 0;
    line-height: 1.4;
  }

  .product-desc {
    font-size: 13px;
    color: #666;
    margin-bottom: 10px;
    line-height: 1.4;
  }

  .product-meta {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #888;
    margin-bottom: 10px;
  }

  .product-image {
    width: 120px;
    height: 120px;
    border-radius: 4px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .product-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 80px;
    /* 与图片同高 */
  }

  .product-header {
    flex: 1;
  }

  .shelf-number {
    font-size: 22px;
    font-weight: bold;
    color: black;
    background: #f8f9fa;
    padding: 6px 12px;
    border-radius: 8px;
    margin: 0;
  }

  .product-footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .quantity {
    font-size: 18px;
    font-weight: bold;
    color: red;
    background: #f0f7ff;
    border-radius: 15px;
    padding: 6px 12px;
    display: inline-flex;
    align-items: center;
  }

  .quantity-number {
    color: red;
    /* 数字变红 */
    font-weight: bold;
    font-size: 20px;
    /* 比"数量"大3px */
  }

  .action-buttons {
    display: flex;
    gap: 10px;
  }

  /* 响应式设计 */
  @media (max-width: 480px) {
    .product-container {
      flex-direction: column;
      gap: 10px;
    }

    .image-container {
      width: 100%;
      height: auto;
      max-height: 200px;
      margin: 0 auto;
    }

    .product-image {
      width: 100%;
      height: auto;
      max-height: 200px;
    }

    .action-buttons {
      flex-direction: column;
      gap: 8px;
      margin-top: 12px;
    }

    .found-btn,
    .not-found-btn {
      width: 100%;
      padding: 12px;
      font-size: 16px;
    }

    .shelf-number,
    .quantity {
      font-size: 16px;
      padding: 8px 12px;
    }

    .product-name {
      font-size: 16px;
      line-height: 1.4;
    }

    .order-header {
      padding: 15px;
    }

    .order-title {
      font-size: 18px;
    }

    .order-id,
    .shop-name {
      font-size: 16px;
    }

    .color-indicator {
      padding: 12px;
      font-size: 18px;
    }
  }

  .found-btn,
  .not-found-btn {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 13px;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .found-btn {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .found-btn.disabled {
    background-color: #cccccc !important;
    cursor: not-allowed;
    opacity: 0.7;
    pointer-events: none;
  }

  .not-found-btn {
    background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .not-found-btn.active {
    transform: translateY(2px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .color-indicator {
    padding: 14px;
    margin-bottom: 15px;
    border-radius: 5px;
    color: white;
    text-align: center;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
  }

  /* 信息容器 */
  .info-container {
    flex: 1;
    /* 占据剩余空间 */
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* 内部元素间距 */
  }

  /* 元信息区域 */
  .meta-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
  }

  .product-container {
    display: flex;
    gap: 20px;
    /* 图片和文字之间的间距 */
    align-items: flex-start;
    /* 顶部对齐 */
  }

  /* 图片容器 - 提高可点击性 */
  .image-container {
    position: relative;
    display: inline-block;
    cursor: pointer;
    flex-shrink: 0;
    /* 防止图片被压缩 */
    width: 120px;
    /* 固定图片宽度 */
    height: 120px;
  }

  /* 图片悬停效果 */
  .image-container:hover .image-overlay {
    opacity: 1;
  }

  /* 图片覆盖层 - 提高可点击性 */
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    opacity: 0;
    transition: opacity 0.3s;
    border-radius: 4px;
  }

  /* 在移动设备上始终显示提示 */
  @media (hover: none) {
    .image-overlay {
      opacity: 1;
      background: rgba(0, 0, 0, 0.2);
      font-size: 12px;
    }
  }

  /* 图片预览模态框 */
  .image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.95);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
  }

  .modal-content {
    position: relative;
    max-width: 95%;
    max-height: 95%;
    width: auto;
    height: auto;
    text-align: center;
  }

  .modal-image {
    max-width: 100%;
    max-height: 80vh;
    border-radius: 4px;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.5);
  }

  /* 改进的关闭按钮 */
  .close-btn-container {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(30, 30, 30, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 1001;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  }

  .close-btn-icon {
    position: relative;
    width: 24px;
    height: 24px;
  }

  .close-bar {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 3px;
    background-color: white;
    border-radius: 2px;
  }

  .close-bar:first-child {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  .close-bar:last-child {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  /* 加载和错误指示器 */
  .loading-indicator,
  .error-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 18px;
    background: rgba(0, 0, 0, 0.6);
    padding: 12px 24px;
    border-radius: 25px;
    z-index: 1001;
  }

  .error-indicator {
    color: #ff6b6b;
  }

  /* 触摸设备优化 */
  @media (pointer: coarse) {
    .image-container {
      min-width: 100px;
      min-height: 100px;
    }

    .close-btn-container {
      width: 50px;
      height: 50px;
      top: 15px;
      right: 15px;
    }

    .close-btn-icon {
      width: 28px;
      height: 28px;
    }
  }

  @keyframes gentlePulse {

    0%,
    100% {
      opacity: 1;
      transform: scale(1);
      text-shadow: 0 0 0 rgba(255, 87, 34, 0);
    }

    25% {
      opacity: 0.95;
      transform: scale(1.4);
      text-shadow: 0 0 3px rgba(255, 87, 34, 0.2);
    }

    50% {
      opacity: 0.85;
      transform: scale(1.3);
      text-shadow: 0 0 6px rgba(255, 87, 34, 0.4);
    }

    75% {
      opacity: 0.9;
      transform: scale(1.25);
      text-shadow: 0 0 4px rgba(255, 87, 34, 0.3);
    }
  }

  .animate-target {
    display: inline-block;
    animation: gentlePulse 1.8s ease-in-out infinite;
    color: #ff5722;
    font-weight: bold;
    will-change: transform, opacity;
    padding: 0 2px;
  }
  
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
  
  .blink-text {
    animation: blink 1.2s ease-in-out infinite;
    font-weight: bold; /* 可选：加粗文本使其更明显 */
  }
  
  .product-divider {
    height: 2px;
    background-color: black; /* 浅灰色分隔线 */
    margin: 12px 0; /* 上下间距 */
    width: 100%;
  }
  
  
  /* 商品清单表格容器 */
  .product-summary-table-container {
    margin-bottom: 15px; /* 与 .color-indicator 的 margin-bottom 一致 */
    background: #fff;
    border-radius: 5px; /* 与 .color-indicator 的 border-radius 一致 */
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #f0f0f0;
  }
  
  /* 表头区域 - 完全匹配 .color-indicator 的样式 */
  .summary-header {
    padding: 14px; /* 与 .color-indicator 的 padding 一致 */
    color: white;
    text-align: center;
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7); /* 与 .color-indicator 的 text-shadow 一致 */
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
  }
  
  .summary-title {
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7); /* 继承父级的文字阴影 */
  }
  
  .summary-count {
    font-weight: bold;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7); /* 继承父级的文字阴影 */
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 14px;
  }
  
  /* 表格包装器 */
  .summary-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    background: white;
  }
  
  /* 表格样式 */
  .summary-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    table-layout: fixed; /* 固定表格布局，使列宽可控 */
  }
  
  /* 列宽定义 */
  .summary-table .col-sn {
    width: 60px; /* 序号列固定宽度 */
    text-align: center;
  }
  
  .summary-table .col-location {
    width: auto; /* 库位码列自适应 */
    text-align: left;
    padding-left: 8px;
  }
  
  .summary-table .col-quantity {
    width: 70px; /* 件数列固定宽度 */
    text-align: center;
  }
  
  .summary-table th {
    background-color: #fafafa;
    padding: 12px 4px; /* 减小左右内边距 */
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #e8e8e8;
    white-space: nowrap;
  }
  
  /* 表头文字对齐 */
  .summary-table th.col-sn {
    text-align: center;
  }
  
  .summary-table th.col-location {
    text-align: left;
    padding-left: 8px;
  }
  
  .summary-table th.col-quantity {
    text-align: center;
  }
  
  .summary-table td {
    padding: 10px 4px; /* 减小左右内边距 */
    border-bottom: 1px solid #f0f0f0;
    color: #444;
  }
  
  /* 单元格对齐 */
  .summary-table td.col-sn {
    text-align: center;
    font-weight: 500;
    color: #666;
  }
  
  .summary-table td.col-location {
    text-align: left;
    padding-left: 8px;
    font-weight: 700; /* 从500改为700，更粗 */
    word-break: break-word;
    font-size: 16px; /* 增加字体大小 */
  }
  
  /* 件数列 - 修改这部分，加大加粗件数 */
  .summary-table td.col-quantity {
    text-align: right;
    font-weight: 700; /* 加粗 */
    font-size: 16px; /* 增加字体大小 */
  }
  
  .summary-table tbody tr:last-child td {
    border-bottom: none;
  }
  
  /* 行状态样式 */
  .summary-table tbody tr.found-row td.col-location,
  .summary-table tbody tr.found-row td.col-quantity {
    color: #52c41a;
  }
  
  .summary-table tbody tr.found-row td.col-sn {
    color: #52c41a;
    font-weight: 600;
  }
  
  .summary-table tbody tr.not-found-row td.col-location,
  .summary-table tbody tr.not-found-row td.col-quantity {
    color: #f5222d;
  }
  
  .summary-table tbody tr.not-found-row td.col-sn {
    color: #f5222d;
    font-weight: 600;
  }
  
  .quantity-badge {
    display: inline-block;
    min-width: 42px; /* 增大最小宽度 */
    padding: 8px 16px; /* 增大内边距 */
    background-color: #1890ff;
    color: white;
    border-radius: 40px; /* 增大圆角 */
    font-size: 32px; /* 增大数字 */
    font-weight: 800;
    text-align: center;
    line-height: 1.4;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* 添加轻微阴影增加立体感 */
  }
  
  /* 已找到状态的徽章颜色 */
  .found-row .quantity-badge {
    background-color: #52c41a;
  }
  
  /* 找不到状态的徽章颜色 */
  .not-found-row .quantity-badge {
    background-color: #f5222d;
  }
  
  /* 移动端适配 - 相应调整 */
  @media screen and (max-width: 768px) {
    .summary-table td.col-location {
      font-size: 15px; /* 移动端稍微减小，但仍比原来大 */
    }
    
    .summary-table td.col-quantity {
      font-size: 16px;
    }
    
    .summary-table td.col-sn {
      font-size: 14px;
    }
    
    .quantity-badge {
        min-width: 36px;
        padding: 6px 12px;
        border-radius: 24px;
        font-size: 22px;
      }
    
    .summary-table th {
      font-size: 14px;
    }
  }
  
  /* 极窄屏幕适配 */
  @media screen and (max-width: 360px) {
    .summary-table td.col-location {
      font-size: 16px;
    }
    
    .summary-table td.col-quantity {
      font-size: 14px;
    }
    
    .quantity-badge {
      min-width: 20px;
      padding: 2px 6px;
      font-size: 18px;
    }
  
  }
  
  /* 向下箭头按钮容器 */
  .expand-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin: 16px 0;
    position: relative;
  }
  
  /* 展开/收起按钮样式 */
  .expand-arrow {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 8px 16px;
    background-color: #f5f5f5;
    border-radius: 8px;
    transition: all 0.3s ease;
    z-index: 1;
  }
  
  .expand-arrow:hover {
    background-color: #e8e8e8;
    transform: translateY(-2px);
  }
  
  .arrow-icon {
    font-size: 24px;
    font-weight: bold;
    color: #1890ff;
    transition: transform 0.3s ease;
  }
  
  /* .expand-arrow.expanded .arrow-icon {
    transform: rotate(180deg);
  } */
  
  .expand-text {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
  
  /* 闪烁箭头样式 */
  .blinking-arrow {
    display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding: 8px 16px;
      background: linear-gradient(135deg, #ff6b6b 0%, #ff4757 100%);
      border-radius: 8px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
  }
  
  
  
  .blinking .arrow-icon {
    animation: blink 1.5s ease-in-out infinite;
    font-size: 28px;
    color: #ff4d4f;
  }
  
  .blinking-arrow:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  }
  
  .blinking-arrow .arrow-icon.blinking {
    animation: blinkAndBounce 1.5s ease-in-out infinite;
    font-size: 28px;
    color: white;
    display: inline-block;
  }
  
  .hint-text {
    font-size: 12px;
      color: white;
      margin-top: 4px;
      white-space: nowrap;
      font-weight: 500;
  }
  
  .blinking-arrow::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 70%);
    animation: pulse 1.5s ease-in-out infinite;
    pointer-events: none;
  }
  
  @keyframes blinkAndBounce {
    0%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
    50% {
      opacity: 0.3;
      transform: translateY(5px);
    }
  }
  
  @keyframes pulse {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    50% {
      opacity: 0.5;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.2);
    }
  }
  
  /* 闪烁动画 */
  @keyframes blink {
    0%, 100% {
      opacity: 1;
      transform: translateY(0);
    }
    50% {
      opacity: 0.3;
      transform: translateY(5px);
    }
  }
  
  /* 商品详情区域过渡动画 */
  .product-list {
    transition: all 0.3s ease;
  }
  
  /* 可选：为商品详情区域添加进入/离开动画 */
  .product-list-enter-active,
  .product-list-leave-active {
    transition: all 0.3s ease;
  }
  
  .product-list-enter,
  .product-list-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
</style>